import { isEmpty } from 'lodash';
export const setCodeList = (permissions, codeList) => {
    if (isEmpty(permissions)) {
        return;
    }
    for (const permission of permissions) {
        codeList.push(permission.code);
        setCodeList(permission.subPermissions, codeList);
    }
};
